import React from 'react';
import type { RealestateAd, RealestateProjectAd } from '../../../types';
import type { AdImageProps } from '../../ad/AdImage';
import { AdImage } from '../../ad/AdImage';

type RealestateImageProps = {
    ad: RealestateAd | RealestateProjectAd;
    aspectClass: string;
    image?: (props: AdImageProps) => React.ReactElement | null;
    imageClass?: string;
    sizes?: string;
};

export function RealestateImage(props: RealestateImageProps) {
    const { ad, aspectClass, image, imageClass, sizes } = props;

    const imageProps = {
        aspectClass,
        crop: true,
        imageClass,
        sizes,
    };

    return image ? (
        image(imageProps)
    ) : (
        <AdImage {...imageProps} {...ad.image} />
    );
}

type PlussRealestateImageProps = RealestateImageProps & {
    secondaryImageWidth?: number;
};

export function PlussRealestateImage(props: PlussRealestateImageProps) {
    const { ad, aspectClass, image, sizes, secondaryImageWidth } = props;

    const secondaryImageUrl =
        ad.image_urls && ad.image_urls.length > 1
            ? ad.image_urls[1]
            : ad.image?.url;

    const imageProps = {
        aspectClass,
        crop: true,
        sizes,
    };

    return image ? (
        image(imageProps)
    ) : (
        <>
            <AdImage {...imageProps} {...ad.image} />
            <AdImage
                {...imageProps}
                url={secondaryImageUrl}
                width={secondaryImageWidth}
            />
        </>
    );
}
